module.exports = __webpack_public_path__ + "img/tarotReader.bc1b816c.jpg";